import { render, staticRenderFns } from "./print_TD.vue?vue&type=template&id=6381ab8e&scoped=true"
import script from "./print_TD.vue?vue&type=script&lang=js"
export * from "./print_TD.vue?vue&type=script&lang=js"
import style0 from "./print_TD.vue?vue&type=style&index=0&id=6381ab8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6381ab8e",
  null
  
)

export default component.exports